import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-help-editing-logbook',
    templateUrl: './help-editing-logbook.component.html',
    styleUrls: ['./help-editing-logbook.component.css'],
    standalone: false
})
export class HelpEditingLogbookComponent implements OnInit {

  // images
  @Input() getImgs: string[] = [];
  @Output() showImg: EventEmitter<string> = new EventEmitter<string>();
  
  constructor() { }

  ngOnInit(): void {
  }

  showImage(url: string): void {
    this.showImg.emit(url);
  }

}
